module.exports = __webpack_public_path__ + "img/mdc.76211853.svg";